import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import AdminLayout from "../../layout/adminLayout";
import { environment, apiRoutes } from "../../auth/apiRoute";
import Axios from "axios";
import {
  Pagination,
  Table,
  Tag,
  Space,
  message,
  notification,
  Popconfirm,
  Button,
  Divider,
  Input,
  Spin,
  Form,
  Select,
  Typography,
  Checkbox,
} from "antd";
import { CloseOutlined } from "@ant-design/icons";
export default function Members() {
  useEffect(() => {
    setLoading(true);
    getMembers();
    getHotels();
    // getQueryAndSetFilter();
    setLoading(false);
  }, []);
  const { Text } = Typography;
  const { Search } = Input;
  const { Option } = Select;
  const [hotelSelectForm] = Form.useForm();
  const [rolesSelectForm] = Form.useForm();
  const [action, setAction] = useState();
  const [member, setMember] = useState({});
  const [loading, setLoading] = useState(false);
  const [hotels, setHotels] = useState([]);
  const [members, setMembers] = useState([]);
  const [filteredMembersData, setFilteredMemberssData] = useState([]);
  const [filteredInfo, setFilter] = useState({});
  const [search, setSearch] = useSearchParams();
  const [pagination, setPagination] = useState();
  const [selectedMember, setSelectedMember] = useState({});
  const roles = [
    { value: "admin", text: "Admin" },
    { value: "member", text: "Member" },
    { value: "judge", text: "Judge" },
    { value: "final_judge", text: "Final Judge" },
  ];
  const tagColors = ["gold", "lime", "green", "cyan", "blue", "geekblue"];
  const getHotels = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].hotels);

      if (response.status == 200) {
        var hotelsData = response.data;
        hotelsData = hotelsData.map((item) => {
          return { ...item, ...{ key: item._id } };
        });
        setHotels(hotelsData);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  const getMembers = async () => {
    try {
      const response = await Axios.post(apiRoutes[environment].allmembers);

      if (response.status == 200) {
        var nominations = response.data;
        nominations = nominations.map((item) => {
          return { ...item, ...{ key: item._id } };
        });

        setMembers(nominations);
        setFilteredMemberssData(nominations);
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
  };
  // const deleteNomination = async (nominationId) => {
  //   setLoading(true);
  //   try {
  //     const response = await Axios.post(
  //       apiRoutes[environment].deleteNomination,
  //       {
  //         nominationId: nominationId,
  //       }
  //     );
  //     console.log(response.data);
  //     if (response.status == 200) {
  //       openNotification();
  //       getNominations();
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       console.log(error.response.data);
  //       console.log(error.response.status);
  //       console.log(error.response.headers);
  //       message.error({
  //         content: "Sorry, there was an error. " + error.response.data.message,
  //         className: "messageBox",
  //       });
  //     }
  //   }
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 3000);
  // };
  const openNotification = (message) => {
    notification.success({
      message: `Success!`,
      description: "Your nomination has been successfully deleted! ",
      placement: "top",
    });
  };
  const onChange = (e) => {
    const value = e.target.value.toLowerCase();
    console.log(value);
    if (!value) {
      setFilteredMemberssData(members);
    } else if (value.length > 4) {
      var filters = members.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredMemberssData([...filters]);
    }
  };
  const getQueryAndSetFilter = () => {
    const params = new URLSearchParams(search);

    var obj = {};
    for (const [key, val] of params.entries()) {
      if (key == "hotel" || key == "category" || key == "firstName") {
        if (obj[key]) {
          obj[key].push(val);
        } else {
          obj[key] = [val.split(",")];
        }
      } else if (key == "current") {
        obj[key] = parseInt(val);
      } else {
        obj[key] = val;
      }
    }
    console.log(obj);
    setFilter(obj);
  };
  const onSearch = (value) => {
    if (!value) {
      setFilteredMemberssData(members);
    } else if (value.length > 2) {
      var filters = members.filter((item) => {
        let keys = Object.keys(item);
        var bool = false;

        keys.forEach((key) => {
          if (key != "_id" && key != "key") {
            if (typeof item[key] === "string" && item[key]) {
              if (item[key].toLowerCase().includes(value)) {
                bool = true;

                return;
              }
            }
          }
        });
        return bool;
      });
      console.log(filters);
      setFilteredMemberssData([...filters]);
    }
  };
  const clearFilters = () => {
    setFilter({ filteredInfo: null });
    setSearch("");
  };
  const handleChange = (pagination, filters, sorter) => {
    console.log({ pagination, filters, sorter });
    const params = new URLSearchParams();

    var newFilters = {};
    if (filters) {
      for (const [key, val] of Object.entries(filters)) {
        if (val) {
          newFilters[key] = val;
        }
      }
      if (Object.keys(newFilters).length > 0) {
        setSearch(newFilters);
        setFilter(newFilters);
      }
    }

    if (pagination) {
      for (const [key, val] of Object.entries(pagination)) {
        if (val) {
          newFilters[key] = val;
        }
      }
      setSearch(newFilters);
      setFilter(newFilters);
    }
  };
  const handleRoleChange = (value) => {
    console.log(value);
  };
  const confirmRoleUpdate = async (values) => {
    console.log(values, selectedMember);
    var newValues = Object.assign({}, selectedMember);
    newValues.roles = values.roles;
    // if selected member is empty, then newValues as values
    // how to check if object is empty
    if (
      Object.keys(selectedMember).length === 0 &&
      selectedMember.constructor === Object
    ) {
      console.log("empty selected member");
      newValues = values;
    }

    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].adminUpdateMemberRole,
        newValues,
      );

      getMembers();
      if (response.status == 200) {
        //
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);

        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const roleAction = () => {
    return (
      <Space>
        <Text>{selectedMember.firstName + " " + selectedMember.lastName} </Text>
        <Form
          form={rolesSelectForm}
          onFinish={(values) => {
            console.log(values);
            confirmRoleUpdate(values);
          }}
          layout={"inline"}
          initialValues={{ roles: selectedMember.roles }}
        >
          <Form.Item name={"roles"}>
            <Select
              mode="multiple"
              allowClear
              style={{ minWidth: "150px" }}
              placeholder="Please select"
              onChange={handleRoleChange}
            >
              {roles.map((role, index) => (
                <Option key={role.value}>{role.text}</Option>
              ))}
            </Select>
          </Form.Item>

          <Button htmlType="submit">Confirm</Button>
        </Form>

        <CloseOutlined
          onClick={() => {
            setSelectedMember({});
          }}
        />
      </Space>
    );
  };
  const confirmHotelUpdate = async (values) => {
    var newMemberData = selectedMember;

    newMemberData.hotels = values.hotels;
    console.log(newMemberData);
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].adminUpdateMemberHotel,
        newMemberData,
      );
      console.log(response);
      if (response.status == 200) {
        getMembers();
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const hotelAction = () => {
    return (
      <Space>
        <Text>{selectedMember.firstName + " " + selectedMember.lastName} </Text>
        <Form
          form={hotelSelectForm}
          onFinish={(values) => {
            console.log(values);
            confirmHotelUpdate(values);
          }}
          layout={"inline"}
          // initialValues={{
          //   hotels: selectedMember.hotels.map((item) => item._id),
          // }}
        >
          <Form.Item name={"hotels"}>
            <Select
              mode="multiple"
              allowClear
              style={{ minWidth: "150px" }}
              placeholder="Please select"
              onChange={handleRoleChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {hotels.map((hotel, index) => (
                <Option key={hotel._id}>{hotel.name}</Option>
              ))}
            </Select>
          </Form.Item>

          <Button htmlType="submit">Confirm</Button>
        </Form>

        <CloseOutlined
          onClick={() => {
            setSelectedMember({});
          }}
        />
      </Space>
    );
  };
  const onChangeCheckbox = (e, record) => {
    console.log(e.target.checked);
    console.log(record);
    setSelectedMember(record);
    var roles = [];
    if (!record.roles) {
      roles.push("judge");
    }

    if (record.roles && !record.roles.includes("judge")) {
      roles = record.roles;
      roles.push("judge");
    }

    // if (record.roles && record.roles.includes("judge")) {
    //   return;
    // }

    var values = { ...record, ...{ roles: roles } };
    console.log({ values });
    confirmRoleUpdate(values);
  };
  const updateMemberAuthDisabled = async (record, disabled) => {
    setLoading(true);
    try {
      const response = await Axios.post(
        apiRoutes[environment].adminUpdateMemberAuthDisabled,
        {
          _id: record._id,
          disabled,
        },
      );

      if (response.status == 200) {
        const updateMember = (item) => {
          if (item._id != record._id) {
            return item;
          }
          return {
            ...item,
            authDisabled: response.data.authDisabled,
          };
        };
        setMembers((currentMembers) => currentMembers.map(updateMember));
        setFilteredMemberssData((currentMembers) =>
          currentMembers.map(updateMember),
        );
        message.success({
          content: disabled ? "User disabled." : "User enabled.",
          className: "messageBox",
        });
      }
    } catch (error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        message.error({
          content: "Sorry, there was an error. " + error.response.data.message,
          className: "messageBox",
        });
      }
    }
    setLoading(false);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "firstName",
      key: "firstName",
      // filteredValue: filteredInfo.firstName || null,
      // sorter: (a, b) => a.hotel.name.localeCompare(b.hotel.name),
      filters: [{ text: "Pending Judge", value: "pending" }],

      onFilter: (value, record) => {
        if (value == "pending") {
          return record.judgePendingApproval === true;
        }
        return true;
      },
      render: (text, record) => {
        return record.firstName + " " + record.lastName;
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Hotels",
      dataIndex: "hotels",
      key: "hotels",
      // filteredValue: filteredInfo.hotels || null,
      // sorter: (a, b) => a.hotel.name.localeCompare(b.hotel.name),
      filters: hotels.map((hotel) => {
        return {
          text: hotel.name,
          value: hotel._id,
        };
      }),
      filterSearch: true,
      onFilter: (value, record) => {
        var bool = false;
        const hotelIds = record.hotels.map((hotel) => hotel._id);
        return record.hotels.map((hotel) => hotel._id).includes(value);
      },
      render: (text, record) => {
        if (record.judgePendingApproval) {
          return record.hotel && record.hotel.name
            ? record.hotel.name
            : "No hotel assigned yet";
        }

        return record.hotels.map((hotel, index) => {
          return (
            <Tag color={tagColors[index]} key={hotel.name + record._id}>
              {hotel.name}
            </Tag>
          );
        });
      },
    },
    {
      title: "Roles",
      key: "roles",
      dataIndex: "roles",
      // filteredValue: filteredInfo.category || null,
      // sorter: (a, b) => a.category.localeCompare(b.category),
      // onFilter: (value, record) => record.roles.includes(value),
      // filters: roles.map((item) => {
      //   return { text: item, value: item };
      // }),
      render: (tag, record) => {
        const colors = ["volcano", "darkSalmon", "geekblue", "green"];

        var roleTags = record.roles.map((role) => {
          const colorIndex = roles.map((item) => item.value).indexOf(role);

          let color = colors[colorIndex];
          return (
            <Tag color={color} key={role + record._id}>
              {role ? roles.find((item) => item.value == role).text : ""}
            </Tag>
          );
        });
        var ifNeedApproval = record.judgePendingApproval ? (
          <Checkbox onChange={(e) => onChangeCheckbox(e, record)}>
            Confirm as judge
          </Checkbox>
        ) : (
          <></>
        );
        return (
          <>
            {roleTags} {ifNeedApproval}
          </>
        );
      },
    },
    {
      title: "Status",
      key: "authDisabled",
      dataIndex: "authDisabled",
      filters: [
        { text: "Enabled", value: false },
        { text: "Disabled", value: true },
      ],
      onFilter: (value, record) => record.authDisabled === value,
      render: (authDisabled) => {
        return authDisabled ? (
          <Tag color="red">Disabled</Tag>
        ) : (
          <Tag color="green">Enabled</Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        const nextDisabledState = !record.authDisabled;
        return (
          <Space size="small">
            <Button
              onClick={() => {
                setAction("roles");
                rolesSelectForm.setFieldsValue({
                  roles: record.roles,
                });
                setSelectedMember(record);
              }}
            >
              Assign Role{" "}
            </Button>

            <Button
              onClick={() => {
                setAction("hotels");
                hotelSelectForm.setFieldsValue({
                  hotels: record.hotels.map((item) => item._id),
                });
                setSelectedMember(record);
              }}
            >
              Update Hotel
            </Button>
            <Popconfirm
              title={
                nextDisabledState
                  ? "Disable this user? They will not be able to log in."
                  : "Enable this user? They will be able to log in again."
              }
              onConfirm={() =>
                updateMemberAuthDisabled(record, nextDisabledState)
              }
              okText={nextDisabledState ? "Disable" : "Enable"}
              cancelText="Cancel"
            >
              <Button danger={nextDisabledState}>
                {nextDisabledState ? "Disable User" : "Enable User"}
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <Spin spinning={loading}>
      <Search
        placeholder="Search ..."
        onSearch={onSearch}
        enterButton
        onChange={onChange}
      />
      <Button onClick={clearFilters}>Clear filters</Button>

      {action == "roles" && selectedMember._id ? (
        <>
          <Divider /> {roleAction()}
        </>
      ) : (
        <></>
      )}
      {action == "hotels" && selectedMember._id ? (
        <>
          <Divider /> {hotelAction()}
        </>
      ) : (
        <></>
      )}

      <Divider />
      <Table
        scroll={{ x: 800 }}
        columns={columns}
        dataSource={filteredMembersData}
        // onChange={handleChange}
      />
    </Spin>
  );
}
